// ---------------------------------------------------------------------------
// Дата импорта модели: приходит в ISO 8601, показываем в локальном виде
// ---------------------------------------------------------------------------

export const avatarDateTimeHandler = (value) => {
    if (!value) {
        return '';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    const pad = (num) => String(num).padStart(2, '0');

    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}, `
        + `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

// ---------------------------------------------------------------------------
// Энергия — внутренняя валюта, приходит строкой с двумя знаками ("150.25")
// ---------------------------------------------------------------------------

export const energyNumber = (value) => {
    const num = Number(value);
    return Number.isNaN(num) ? 0 : num;
};

// В макете разряды разделены пробелом, хвостовые нули не показываются
export const energyHandler = (value) => {
    const num = energyNumber(value);
    const trimmed = Number(num.toFixed(2));

    const [int, dec] = String(trimmed).split('.');
    const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return dec ? `${grouped},${dec}` : grouped;
};

// Сколько не хватает до цены разблокировки
export const energyMissing = (energy, price) => {
    const diff = energyNumber(price) - energyNumber(energy);
    return diff > 0 ? diff : 0;
};


// ---------------------------------------------------------------------------
// Покупка энергии через платёжный шлюз
// ---------------------------------------------------------------------------

// Курс приходит строкой с восемью знаками ("1.00000000") — в интерфейсе это шум.
// Показываем два, но у совсем мелкого курса добираем знаки, чтобы он не
// превратился в 0.00
export const rateHandler = (value) => {
    const num = Number(value);
    if (!num || Number.isNaN(num)) {
        return '0.00';
    }

    let digits = 2;
    while (Number(num.toFixed(digits)) === 0 && digits < 8) {
        digits += 1;
    }

    return num.toFixed(digits);
};

// Цена произвольного количества энергии: energy × rate, округление ВВЕРХ до цента
export const customEnergyPrice = (energy, rate) => {
    const total = energyNumber(energy) * Number(rate || 0);
    return Math.ceil(total * 100) / 100;
};

// В API у пакета нет признака выгоды, а в макете он есть — считаем сами:
// насколько пакет дешевле той же энергии, купленной произвольной суммой
export const packBonusHandler = (pack, custom) => {
    if (!custom?.rate) return 0;

    const base = customEnergyPrice(pack?.energy, custom.rate);
    const price = Number(pack?.price);

    if (!base || !price || price >= base) return 0;

    return Math.round((1 - price / base) * 100);
};

// payment_options отдают сумму в минимальных единицах токена
export const tokenAmountHandler = (amount, decimals) => {
    const raw = String(amount ?? '');
    const dec = Number(decimals);

    if (!raw || Number.isNaN(dec)) return raw;

    const num = Number(raw) / Math.pow(10, dec);
    if (Number.isNaN(num)) return raw;

    // у токенов бывает 18 знаков — лишние нули пользователю не нужны
    return String(Number(num.toFixed(6)));
};

// Остаток времени на оплату счёта, в секундах
export const secondsLeftHandler = (expiresAt) => {
    if (!expiresAt) return 0;
    const diff = Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000);
    return diff > 0 ? diff : 0;
};

export const timerHandler = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
};
